import React from 'react';
import { Spinner, Box, Layer } from 'grommet';

interface Props {
  isLoading?: boolean;
}

function FullPageSpinner({ isLoading }: Props): JSX.Element | null {
  return isLoading ? (
    <Layer animate={false} full>
      <Box align='center' justify='center' direction='row' fill>
        <Spinner size='medium' />
      </Box>
    </Layer>
  ) : null;
}

export default FullPageSpinner;
